import React from "react";
import { resultLabelClass } from "./resultLabel";

const LatestResult = ({ item }) => {
  return (
    <span
      className={resultLabelClass(item.result)}
      dataTooltip
      title={item.opponent + " " + item.match_home_or_away + " " + item.match_score}
      style={{ fontWeight: "700", marginLeft: ".15rem", marginRight: ".15rem", width: "2.2em", textAlign: "center"}}
    >
      {item.result}
    </span>
  );
};

export default LatestResult;
